<mat-form-field class="full-width">

  <mat-label ssFormLabel></mat-label>

  <ss-text-area-control></ss-text-area-control>

  <mat-error ssFormValidationMessage></mat-error>
  
  <mat-spinner diameter="24" *ngIf="(statusObs | async)==='PENDING'" matSuffix></mat-spinner>

</mat-form-field>